<template>
  <v-dialog v-model="dialog" max-width="765" @input="beforeClose">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined color="#E03210" class="mb-6 button-height" v-bind="attrs" v-on="on">sair do clube</v-btn>
    </template>
    <v-card class="pt-2 pb-3 quit-clube-container">
      <v-card-title>
        <p class="titulo mb-0" :style="{ color: getAssets && getAssets.color ? getAssets.colors.primaryButtonBackground : '' }">Sair do clube</p>
        <v-flex class="close-dialog">
          <v-btn icon @click="dialog = false"><v-icon>close</v-icon></v-btn>
        </v-flex>
      </v-card-title>
      <v-card-text v-if="hideContact">
        <div class="texto mb-5">
          <p>
            Saindo do clube você deixa de receber nossas promoções e também deixa de ter acesso aos descontos oferecidos com exclusividade aos membros do nosso
            clube fidelidade. Você tem certeza?
          </p>
        </div>

        <strong class="mb-2">Informe o e-mail pelo qual te atualizaremos sobre a sua solicitação:</strong>
        <v-text-field
          v-model="email"
          outlined
          label="E-mail"
          type="text"
          class="mb-2"
          name="email"
          :error-messages="error"
          :hide-details="!error"
          @blur="validateField"
        />
        <div class="mb-5">
          <span class="link" @click="hideContact = false">Eu não possuo endereço de e-mail</span>
        </div>
        <strong class="mb-2">Motivo da solicitação:</strong>
        <v-textarea
          v-model="motive"
          outlined
          label="Descreva o motivo da sua solicitação"
          class="mb-2"
          rows="3"
          :color="getAssets.colors.form.buttonBackground"
        />
        <v-btn
          class="button-height"
          :loading="btnLoading"
          :disabled="!email || !motive || !!error"
          :width="isMobile ? '100%' : ''"
          :class="isMobile ? 'mb-3' : 'mr-5'"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          @click="deleteData"
          >Sair do clube</v-btn
        >
        <v-btn class="button-height" :width="isMobile ? '100%' : ''" text color="#B3280D" @click="dialog = false">cancelar</v-btn>
      </v-card-text>
      <contact-content v-else />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'QuitClubeModal',
  inject: ['$validator'],
  components: {
    ContactContent: () => import('@/modules/units/views/components/ContactContent.vue')
  },
  data: () => ({
    dialog: false,
    email: '',
    motive: '',
    hideContact: true,
    error: '',
    btnLoading: false
  }),
  computed: {
    getAssets() {
      return this.$store.getters.GET_ASSETS
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
    getEmail() {
      return this.$store.getters.USER_INFO.email
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue && this.getEmail) this.email = this.getEmail
    }
  },
  methods: {
    beforeClose() {
      this.hideContact = true
      this.email = ''
      this.motive = ''
      this.error = ''
    },
    deleteData() {
      this.btnLoading = true
      this.$store
        .dispatch('createDeleteDataRequest', { email: this.email, data: ['all'], motive: this.motive })
        .then(() => {
          this.$router.push({ name: 'solicitacao-realizada', params: { all: true } })
        })
        .catch(err => {
          const error = err['response'].errors[0]
          const pendingRequestMessageError = 'This user already has a pending delete data request'
          let snackbarMessage = 'Ocorreu um erro. Tente novamente mais tarde'
          if (pendingRequestMessageError === error.message) {
            snackbarMessage = 'Já existe uma solicitação de exclusão de dados pendente'
          }
          this.$snackbar({
            message: snackbarMessage,
            snackbarColor: 'error'
          })
          console.error(err)
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    validateField() {
      this.error = ''
      this.$validator.validate('email', this.email).then(valid => {
        if (!this.email || !valid) {
          this.error = 'Esse campo precisa ter um e-mail válido.'
          return
        }
        this.error = ''
      })
    }
  }
}
</script>

<style lang="scss">
$tablet-size: 960px;

.quit-clube-container {
  & .v-card__text {
    max-width: calc(100% - 30px);
  }
  & .titulo {
    font-family: 'Roboto', medium;
    font-weight: 500;
    font-size: 20px;
  }
  & .texto {
    & p {
      text-align: left;
      font-family: 'Roboto', sans-serif;
      font-size: 14px !important;
      color: #6b7580;
      line-height: 150%;
    }
  }
  & .fechar {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 14px !important;
    line-height: 16px !important;
    text-align: center;
    letter-spacing: 0.75px;
    text-transform: uppercase;
  }

  & .link {
    font-size: 14px;
    color: #0079f2;
    cursor: pointer;
    text-decoration: underline;
  }

  & .close-dialog {
    text-align: right;
  }

  & strong {
    color: #4b525a;
    font-weight: 500;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    display: block;
  }
}
</style>
